import loadable from '@loadable/component'

export default [
  {
    path: '/inviteFission',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-InviteFission-index" */ '~/pages/InviteFission/pages/index'
        )
    ),
  },
  {
    path: '/inviteFission/record',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-InviteFission-record" */ '~/pages/InviteFission/pages/record'
        )
    ),
  },
  {
    path: '/inviteFission/entry',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-InviteFission-entry" */ '~/pages/InviteFission/pages/entry'
        )
    ),
  },
  {
    path: '/inviteFission/land',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-InviteFission-land" */ '~/pages/InviteFission/pages/land'
        )
    ),
  },
  {
    path: '/ifln/:code',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-InviteFission-landNew" */ '~/pages/InviteFission/pages/landNew'
        )
    ),
  },
]
